var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-icon btn-1 btn-rounded",on:{"click":function($event){return _vm.$emit('reached')}}},[_c('i',{staticClass:"fa fa-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }